import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todos os solos cadastradas no banco de dados
 */
const getAllSolos = async () => {
	return registryApi.get('v1/Solo')
}

/**
 * Retorna todos os tipos de solos para o componente de DropdownFk
 */
const getDropdownSolos = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/Solo/GetDropdown')
	return result.map((solo) => {
		return {
			id: solo.id,
			[i18n.t('code')]: `TS-${solo.tpsl_cd_codigo}`,
			[i18n.t('acronym')]: solo.tpsl_nm_sigla,
			[i18n.t('description')]: solo.tpsl_ds_descricao,
		}
	})
}

/**
 * Cadastrar novo solo no banco de dados
 * @param {Object} body solo que será cadastrada
 */
const createSolo = async (body) => {
	return registryApi.post('v1/Solo', body)
}

/**
 * Atualiza solo no banco de dados
 * @param {Object} body Solo que será atualizada
 */
const updateSolo = async (body) => {
	return registryApi.put('v1/Solo', body)
}

/**
 * Lista dos ids de solo que devem ser excluidos do banco de dados
 * @param {Array} data Lista dos ids de solo
 */
const deleteSoloByIdList = async (data) => {
	return registryApi.delete('v1/Solo/DeleteByIdList', { data })
}

export { getAllSolos, getDropdownSolos, createSolo, updateSolo, deleteSoloByIdList }
